import Pagina, { PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import { TypeResponsavel } from "../../../Models/Domain/Pessoa/Responsavel";
import { TypePessoaObfuscada } from "../../../Models/Pessoa/Pessoa";
import { Axios } from "../../Axios";
import RequestUtilitario from "@/Utils/RequisicaoUtilitario";

export class ResponsavelService {
    public listar(filtro?: TypeResponsavel) {
        return Axios.post<TypeResponsavel[]>(`quiron/pessoa/responsavel/listar`, filtro);
    }

    public listarPagina(paginaInfo?:PaginaInfo, responsavel?: TypeResponsavel) {
        const queryString = RequestUtilitario.objectToQueryString({
            paginaInfo,
            filtro : responsavel
        });
        return Axios.get<Pagina<TypeResponsavel>>(`quiron/pessoa/responsavel/pagina?${queryString}`);
    }

    public inserir(payload: TypeResponsavel) {
        return Axios.post<TypeResponsavel>(`quiron/pessoa/responsavel`, payload);
    }

    public atualizar(payload: TypeResponsavel) {
        return Axios.put<void>(`quiron/pessoa/responsavel`, payload);
    }

    public ativar(codigoDoResponsavel: number) {
        return Axios.patch<void>(`quiron/pessoa/responsavel/${codigoDoResponsavel}/ativar`);
    }

    public desativar(codigoDoResponsavel: number) {
        return Axios.patch<void>(`quiron/pessoa/responsavel/${codigoDoResponsavel}/desativar`);
    }

    public static GET<BuscandoComo extends "responsavel" | "administrador" = "administrador">(filtro: { cpf?: string} ) {
        type Retorno = BuscandoComo extends "administrador" ? TypeResponsavel[] : TypePessoaObfuscada[];

        return Axios.get<Retorno>(`quiron/pessoa/responsavel`, {params: filtro});
    }

}